"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCustomIdentOrNull = exports.getCustomIdent = void 0;
const character_1 = require("./character");
const skip_1 = require("./skip");
const Error_1 = require("./Error");
const getCustomIdent = (input, start) => {
    const value = (0, exports.getCustomIdentOrNull)(input, start);
    if (value) {
        return value;
    }
    throw new Error_1.$Error('NoIdent', [input.slice(0, start), input.slice(start)].join('→'));
};
exports.getCustomIdent = getCustomIdent;
const getCustomIdentOrNull = (input, start) => {
    let end = start;
    const fragments = [];
    while (1) {
        const fragmentStart = end;
        end = (0, skip_1.skip)(input, end, character_1.isIdentCharacter);
        fragments.push(input.slice(fragmentStart, end));
        if (input.codePointAt(end) === character_1.Backslash) {
            end += 1;
            const hexEnd = (0, skip_1.skip)(input, end, character_1.isHexCharacter);
            if (end < hexEnd) {
                const cp = Number.parseInt(input.slice(end, hexEnd), 16);
                fragments.push(String.fromCodePoint(cp));
                end = hexEnd;
            }
            else {
                fragments.push(input.charAt(end));
                end += 1;
            }
        }
        else {
            break;
        }
    }
    const value = fragments.join('');
    if (value) {
        return { start, end, value };
    }
    return null;
};
exports.getCustomIdentOrNull = getCustomIdentOrNull;
